import HttpClient from "HttpClient";
import { IApiResponse, IUserInfo } from "../../Interface/Shared/ApiResponse";
import store from "../../Redux/Store/AppStore";
import routes from "../../Routes/Routes.json";

const isExternalLoginPath =
  window.location.pathname.toLowerCase().replace(/\/$/, "") ===
  "/externallogin";

const userLogin = async (user: any, portalKey?: string) => {
  const response: IApiResponse<IUserInfo> = await HttpClient().post(
    `/${routes.Login}`,
    user,
    {
      headers: {
        ExternalLogin: isExternalLoginPath ? window.location.href : "",
        ...(portalKey ? { "X-Portal-Key": portalKey } : {}),
      },
    }
  );
  return response;
};

const switchPortal = async (key: string, token: string, labId: number) => {
  const response = await HttpClient().post(
    `/${routes.UserManagement.SelectTenantLogin}?labId=${labId}`,
    null,
    {
      headers: {
        "X-Portal-Key": key,
        Authorization: `Bearer ${token}`,
        Lab: labId,
      },
    }
  );

  return response;
};

const userLogout = () => {
  return HttpClient().post(`/${routes.Logout}`, {
    refreshToken: (store as any).getState()?.Reducer?.refreshToken,
  });
};

const getAuthenticatorStatus = () => {
  return HttpClient().get(`/${routes.UserManagement.GetAuthenticatorStatus}`);
};

const startAuthenticatorSetup = () => {
  return HttpClient().post(
    `/${routes.UserManagement.StartAuthenticatorSetup}`,
    null
  );
};

const verifyAuthenticatorSetupCode = (verificationCode: string) => {
  return HttpClient().post(
    `/${routes.UserManagement.VerifyAuthenticatorSetupCode}`,
    { verificationCode }
  );
};

const completeAuthenticatorSetup = (password: string) => {
  return HttpClient().post(
    `/${routes.UserManagement.CompleteAuthenticatorSetup}`,
    { password }
  );
};

const confirmAuthenticatorRemoval = (password: string) => {
  return HttpClient().post(
    `/${routes.UserManagement.ConfirmAuthenticatorRemoval}`,
    { password }
  );
};

const cancelAuthenticatorBeforePassword = () => {
  return HttpClient().post(
    `/${routes.UserManagement.CancelAuthenticatorBeforePassword}`,
    null
  );
};

const AccountService = {
  userLogin,
  userLogout,
  switchPortal,
  getAuthenticatorStatus,
  startAuthenticatorSetup,
  verifyAuthenticatorSetupCode,
  completeAuthenticatorSetup,
  confirmAuthenticatorRemoval,
  cancelAuthenticatorBeforePassword,
};
export default AccountService;
